import { createAction } from 'redux-actions';
export const addSelectedSeats = createAction('ADD_SELECTED_SEATS');
export const removeSelectedSeats = createAction('REMOVE_SELECTED_SEATS');
export const clearSelectedSeats = createAction('CLEAR_SELECTED_SEATS');
export const setSelectedSeatsBySegment = createAction('SET_SELECTED_SEATS_BY_SEGMENT');
